export function withEvidensiaUtm(url: string): string {
  const link = new URL(url);
  link.searchParams.set('utm_source', 'getapet.se');
  link.searchParams.set('utm_medium', 'banner_inchatt');
  link.searchParams.set('utm_campaign', 'valpkatt_2026_autumn');
  link.searchParams.set('utm_content', '-banner');
  return link.toString();
}
